<div class="summary-container p-3">
  <div class="ready-to-import_container">
    <h4><i class="fas fa-check"></i> Ready to Import</h4>

    <div
      class="content"
      [ngClass]="{
        'grey-background': !analysisSummaryData,
        'border border-primary': analysisSummaryData
      }"
    >
      <div
        *appLoadingIndicator="{
          show: !analysisSummaryData && analysisLoading,
          showBackdrop: false,
          fullPage: false,
          message: 'Loading'
        }"
      ></div>

      <div
        class="no-file"
        *ngIf="!areColumnsMapped && hasSelectedFile && !analysisLoading"
      >
        Columns must be mapped first.
      </div>

      <div class="no-file" *ngIf="!hasSelectedFile && !analysisLoading">
        No File Selected
      </div>

      <h5 *ngIf="analysisSummaryData">
        We found
        <small>{{ analysisSummaryData.recordMatchedCount }}</small> products to
        import
      </h5>
    </div>
  </div>

  <div *ngIf="analysisSummaryData" class="not-importing_container">
    <div class="header">
      <h4>
        <i class="fas fa-ban"></i> Not Importing
        <small>{{
          analysisSummaryData.recordViolationCount + ' ' + uploadTypeLabel
        }}</small>
      </h4>

      <div class="d-flex">
        <!-- SEND FOR REVIEW button -->
        <div
          *ngIf="isSendForReviewAllowed"
          [ngbPopover]="
            sentForReviewCount != null && sentForReviewCount >= 0
              ? sentForReviewCount + ' Products Sent for Review.'
              : ''
          "
          [openDelay]="1000"
          [autoClose]="false"
        >
          <button
            data-test-selector="send-for-review-button"
            class="btn send-for-review-button d-flex me-4"
            [disabled]="
              sentForReviewCount != null ||
              !analysisSummaryData.sendForReviewCount
            "
            (click)="sendForReview()"
          >
            Send for Review
            <i *ngIf="sentForReviewCount !== -1" class="fa fa-share-square text-success"></i>
            <ng-container *ngIf="sentForReviewCount === -1">
              <span
                *appLoadingIndicator="{
                  show: true,
                  showBackdrop: false,
                  fullPage: false,
                  message: ''
                }"
              ></span>
            </ng-container>
          </button>
        </div>

        <!-- DOWNLOAD button -->
        <button
          class="btn"
          (click)="download()"
          [disabled]="downloading"
          *ngIf="analysisSummaryData.downloadUrl"
        >
          <span *ngIf="!downloading"
            >Download <i class="fas fa-download text-success"></i
          ></span>
          <ng-container *ngIf="downloading">
            <span
              *appLoadingIndicator="{
                show: true,
                showBackdrop: false,
                fullPage: false,
                message: 'Downloading...'
              }"
            ></span>
          </ng-container>
        </button>
      </div>
    </div>

    <!--
      Violations summary content
    -->
    <div
      class="content"
    >
      <div>
        <div
          data-test-selector="violation-item"
          class="violations"
          *ngFor="let violation of analysisSummaryData.analysisViolations"
        >
          <span>{{ violation.message }}</span>

          <span
            class="badge badge-pill"
            data-test-selector="violation-badge"
            [ngClass]="{
              'bg-danger': violation.alertLevel === alertLevels.HIGH,
              'bg-warning': violation.alertLevel === alertLevels.MEDIUM,
              'bg-secondary': violation.alertLevel === alertLevels.LOW
            }"
          >
            {{ violation.badge }}
          </span>
        </div>
      </div>
    </div>
  </div>
</div>
